import { BannerProps } from "./types";
import clsx from "clsx";

const Banner = ({ header }: BannerProps) => {
  return (
    <div
      className={clsx(
        "flex",
        "w-full",
        "h-16",
        "lg:h-24",
        "justify-center",
        "items-center",
        "bg-white",
        "border-b-0",
        "border-gray-400",
        "shadow-md"
      )}
    >
      <h1 className='text-reece-800 text-2xl lg:text-4xl font-bold'>{header}</h1>
    </div>
  );
};

export default Banner;
